import React, { Fragment } from "react";
import style from "./styles.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";

const renderLabel = (data, prop) => {
  const { label } = data;
  const { renderContent, onClick, loadingId, selected } = prop;

  const childNodes = [];
  if (typeof renderContent === "function") {
    let vnode = renderContent(data);
    if (vnode && loadingId == data.id) {
      vnode = <NodeLoading key={`node-loading-${data.id}`}>{vnode}</NodeLoading>;
    }
    vnode && childNodes.push(vnode);
  } else {
    childNodes.push(label);
  }

  const cls = [];

  if (data.id == selected) {
    cls.push(style.selected);
  }

  cls.push(style.treeNodeLabelInner);

  return (
    <div className={style.treeNodeLabel}>
      <div
        disabled={data.id == selected}
        className={cls.join(" ")}
        onClick={(e) => typeof onClick === "function" && onClick(e, data)}
      >
        {childNodes}
      </div>
    </div>
  );
};

const directionType = {
  LEFT: "left",
  RIGHT: "right",
  BOTH: "both",
};

const renderNode = (data, currentNode, previousNode, direction, prop) => {
  const cls = [style.treeNode];
  const childNodes = [];

  if (direction === directionType.LEFT || direction === directionType.BOTH) {
    if (currentNode.parents.length > 0) {
      childNodes.push(
        <div key={`parents-${currentNode.id}`} className={style.treeNodeParent}>
          {currentNode.parents.map((parent) => (
            <Fragment key={`node-${parent.id}`}>
              {renderNode(data, data[parent.id], currentNode, directionType.LEFT, prop)}
            </Fragment>
          ))}
        </div>
      );
    } else {
      cls.push(style.isLeaf);
    }
    if (direction === directionType.LEFT && previousNode) {
      if (currentNode.children.find((child) => child.id !== previousNode.id)) {
        // The current node has more children than the "previous node".
        cls.push(style.hasMoreChilds);
      }
    }
  }

  childNodes.push(<Fragment key={`node-label-${currentNode.id}`}>{renderLabel(currentNode, prop)}</Fragment>);

  if (direction === directionType.RIGHT || direction === directionType.BOTH) {
    if (currentNode.children.length > 0) {
      childNodes.push(
        <div key={`childs-${currentNode.id}`} className={style.treeNodeChildren}>
          {currentNode.children.map((children) => (
            <Fragment key={`node-${children.id}`}>
              {renderNode(data, data[children.id], currentNode, directionType.RIGHT, prop)}
            </Fragment>
          ))}
        </div>
      );
    } else {
      cls.push(style.isLeaf);
    }
    if (direction === directionType.RIGHT && previousNode) {
      if (currentNode.parents.find((parent) => parent.id !== previousNode.id)) {
        // The current node has more parents than the "previous node".
        cls.push(style.hasMoreParents);
      }
    }
  }

  return <div className={cls.join(" ")}>{childNodes}</div>;
};

export const render = ({ data, ...props }) => {
  if (!(data && props)) {
    return null;
  }

  const { selected } = props;
  const currentNode = data[selected];

  if (!currentNode) {
    return null;
  }

  return renderNode(data, currentNode, null, directionType.BOTH, props);
};

export default render;

const NodeLoading = ({ children }) => (
  <div className={style.loadingWrapper}>
    <div className={style.nodeLoading}>
      <CircularProgress sm style={{ margin: "0px auto" }} />
    </div>
    {children}
  </div>
);
